<div class='primary-bg-color sister-upsell shadowed'>

  <div class="image-wrapper" aria-hidden="true">
    <img class='img-fluid full-width' ftsPicture #pictureRef='pictureRef' [imgSrc]='imageUrl'
         alt="{{upsell.orderableItem.label}}" (pictureSet)="onPictureSet()"/>
    <fts-ghost-element *ngIf='imageUrl  && !pictureRef?.isLoaded' [height]="120"></fts-ghost-element>
  </div>

  <div class="sister-info pb-1">
    <div class="sister-name-cals">
      <span class='font-secondary fw-400 padded-horiz-15 mt-2 panel-item-name'>
        {{upsell.orderableItem.label}}<sup *ngIf="upsell.orderableItem.labelSymbol">{{upsell.orderableItem.labelSymbol}}</sup>
      </span>
      <p class='padded-horiz-15 margin-top-10 fw-500 calories-display' *ngIf='calories'>{{calories}}</p>
    </div>
  
    <div class="padded-horiz-15" *ngIf="upsell.unsatisfiedIngredientChoice?.name" [ngClass]="{'pt-2 pb-2': panelItem.sizePrices.length !== 1, 'padding-bottom': panelItem.sizePrices.length === 1}">
      <fts-single-ingredient-choice
          [unsatisfiedIngredientChoice]="upsell.unsatisfiedIngredientChoice"
          [selectedSizePrice]="selectedSizePrice"
          (ingredientChange)="onIngredientChange($event)"
          (qualifierChange)="onQualifierChange($event)">
        </fts-single-ingredient-choice>
    </div>
  
    <div class='padded-horiz-15 pb-2'>
      <fts-size-prices
        [itemName]='panelItem.name'
        [sizePrices]="panelItem.sizePrices"
        [(selectedSizePrice)]="selectedSizePrice"
        (selectedSizePriceChange)='onSizeChange($event)'></fts-size-prices>
    </div>
  
    <div class="padded-horiz-15">
      <fts-quantities [label]="'component.quantities.quantity_label' | translate" [(selectedQuantity)]="selectedQuantity"
                      [minimumQuantity]="upsell.orderableItem?.minimumQuantity"></fts-quantities>
    </div>
  
    <div class='padded-horiz-15 padded-vert-15'>
      <fts-size-price-button
        class='full-width'
        [menuItemsLayout]="menuItemsLayoutEnum.CardMenu"
        [isUpsell]="true"
        [isSister]="true"
        [panelItem]='panelItem'
        [quantity]="selectedQuantity"
        [sizePrice]='selectedSizePrice'
        [upsellType]='upsellType'
        [upfrontIngredient]='selectedUpfrontIngredient'
        [upfrontChoice]='upsell?.unsatisfiedIngredientChoice?.name'
        [upfrontQualifiers]='upfrontQualifiers'
      ></fts-size-price-button>
    </div>
  </div>

</div>
